import { render, staticRenderFns } from "./SubscriptionTypeTabs.vue?vue&type=template&id=1e35cccd"
import script from "./SubscriptionTypeTabs.vue?vue&type=script&lang=js"
export * from "./SubscriptionTypeTabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports